import { HeroStatTile } from '../components/HeroStatTile';

/**
 * Sweep Log visual shell. Admin-only. Ports v0.7 LogPage (index.html
 * line ~5927).
 *
 * v0.7 behavior: chronological history of every data sweep with date,
 * signals found, queries run, source list, and elapsed time. Used to
 * monitor ingest health and diagnose source failures.
 *
 * Stream 0 ships the shell. Stream 3A wires the sweep_logs table and
 * the sweep execution. Stream 0 itself does NOT execute sweeps.
 */
export function SweepLog() {
  return (
    <div>
      <div className="bdse-hero">
        <div className="bdse-hero-row">
          <div>
            <h1 className="bdse-hero-title">Sweep Log</h1>
            <p className="bdse-hero-subtitle">
              Data sweep history with source counts and duration
            </p>
          </div>
        </div>

        <div className="bdse-hero-stats">
          <HeroStatTile label="Sweeps" value="0" sub="total" icon="history" />
          <HeroStatTile label="Last" value="—" sub="no sweeps yet" icon="clock" />
          <HeroStatTile label="Signals" value="0" sub="captured" icon="activity" />
          <HeroStatTile label="Avg Time" value="—" sub="per sweep" icon="clock" />
        </div>
      </div>

      <section className="bdse-sweep-log">
        <div className="bdse-empty-state-large">
          <p className="bdse-empty-icon">{'\u{23F1}'}</p>
          <p className="bdse-empty-title">No sweeps yet</p>
          <p>
            Sweep history will appear here once Stream 3A wires the data
            ingest backend. Each entry shows date, signals found, queries
            run, sources used, and elapsed time.
          </p>
        </div>
      </section>
    </div>
  );
}
